import SimplePage from "@/components/simple-page/index";
import PAGE from "./page.yaml";

export default {
  components: { SimplePage },
  data() {
    return {
      sections: PAGE.sections,
      title: PAGE.title,
    };
  },
};
